import { render, staticRenderFns } from "./HotelFacilityDisplayGroup.vue?vue&type=template&id=38303576&"
import script from "./HotelFacilityDisplayGroup.vue?vue&type=script&lang=js&"
export * from "./HotelFacilityDisplayGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38303576')) {
      api.createRecord('38303576', component.options)
    } else {
      api.reload('38303576', component.options)
    }
    module.hot.accept("./HotelFacilityDisplayGroup.vue?vue&type=template&id=38303576&", function () {
      api.rerender('38303576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/HotelFacilityDisplayGroup.vue"
export default component.exports